// extracted by mini-css-extract-plugin
export default {"box":"HeaderInputUI_box__ZyYX2"};